export const PRICE_VARIANTS_WIDGET_COMPONENT_IDS = {
  variantsRepeater: '#variantsRepeater',
  variantName: '#variantName',
  variantPrice: '#variantPrice',
  variantCurrency: '#variantCurrency',
  variantDivider: '#variantDivider',
} as const;

export const UNSELECTED_VARIANTS_COMPONENT_IDS = Object.values(PRICE_VARIANTS_WIDGET_COMPONENT_IDS);
